module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('section', [_c('div', {
    staticClass: "tab-wrap"
  }, _vm._l((_vm.days), function(day, index) {
    return _c('div', {
      staticClass: "tab-item",
      class: {
        actived: _vm.nowTab === index
      },
      on: {
        "click": function($event) {
          _vm.nowTab = index
        }
      }
    }, [_vm._v(_vm._s(day))])
  })), _c('div', {
    staticClass: "mb-3"
  }), _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "6px",
      "color": "#868686"
    }
  }, [_vm._v("*以現場活動執行時間為主")])]), _c('div', {
    staticClass: "mb-4"
  }), (_vm.nowTab === 0) ? _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.days[0]) + " 節目表")]), _c('div', {
    staticClass: "mb-4"
  }), _vm._m(0)]) : _vm._e(), (_vm.nowTab === 1) ? _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.days[1]) + " 節目表")]), _c('div', {
    staticClass: "mb-4"
  }), _vm._m(1)]) : _vm._e(), (_vm.nowTab === 2) ? _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.days[2]) + " 節目表")]), _c('div', {
    staticClass: "mb-4"
  }), _vm._m(2)]) : _vm._e(), (_vm.nowTab === 3) ? _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.days[3]) + " 節目表")]), _c('div', {
    staticClass: "mb-4"
  }), _c('div', {
    staticClass: "program-list"
  }, [_vm._m(3), _c('div', {
    staticClass: "list col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_vm._v("BYOC舞台")]), _c('div', {
    staticClass: "list-content"
  }, [_c('ul', _vm._l((1), function(show) {
    return _c('li', [_c('div', {
      staticClass: "time"
    }, [_vm._v("14:30-16:00")]), _vm._m(4, true)])
  }))])]), _vm._m(5)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "program-list"
  }, [_c('div', {
    staticClass: "list col-sm-4 col-md-3 col-md-offset-1"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_vm._v("主舞台")]), _c('div', {
    staticClass: "list-content"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("10:30-11:30")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("WirForce 2017 記者會")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("12:00-20:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("台北盃電競大賽"), _c('br'), _vm._v("個人項目 16 強總決賽 -《快打旋風V》")])])])])]), _c('div', {
    staticClass: "list col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_vm._v("BYOC舞台")]), _c('div', {
    staticClass: "list-content"
  }, [_c('ul')])]), _c('div', {
    staticClass: "list col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_vm._v("野台")]), _c('div', {
    staticClass: "list-content"
  }, [_c('ul')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "program-list"
  }, [_c('div', {
    staticClass: "list col-sm-4 col-md-3 col-md-offset-1"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_vm._v("主舞台")]), _c('div', {
    staticClass: "list-content"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("11:30-14:30")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("《部落衝突:皇室戰爭》"), _c('br'), _vm._v("2017皇冠錦標賽東南亞賽區外卡賽")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("14:30-17:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("BYOC Fight"), _c('br'), _vm._v("PC《絕對武力：1.6》總決賽")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("17:00-20:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("NVIDIA X 天命 2"), _c('br'), _vm._v("三人成軍，奪回家園！")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("22:00-23:30")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("WirForce 2017 開幕演出")])])])])]), _c('div', {
    staticClass: "list col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_vm._v("BYOC舞台")]), _c('div', {
    staticClass: "list-content"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("18:00-19:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("Twitch 神秘活動")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("19:00-21:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("ROG X WirForce"), _c('br'), _vm._v("第一神拳")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("24:00-01:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("WirForce 大胃王 III")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("01:00-02:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("鮮乳坊 X WirForce 擠牛奶")])])])])]), _c('div', {
    staticClass: "list col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_vm._v("野台")]), _c('div', {
    staticClass: "list-content"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("16:30 - 17:30")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("ahq 誓師大會")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("18:00 - 19:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("双響泡熱血運動會")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("19:00 - 20:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("6tan x 惡王："), _c('br'), _vm._v("職業摔角 x Gamer訪談")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "program-list"
  }, [_c('div', {
    staticClass: "list col-sm-4 col-md-3 col-md-offset-1"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_vm._v("主舞台")]), _c('div', {
    staticClass: "list-content"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("11:00-14:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("中華電信 BYOC Fight"), _c('br'), _vm._v("《英雄聯盟》總決賽")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("14:00-17:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("Shadowverse"), _c('br'), _vm._v("台日韓邀請賽")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("17:30-20:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("AORUS BYOC Fight"), _c('br'), _vm._v("《絕地求生》總決賽")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("22:00-24:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("WirForce 2017"), _c('br'), _vm._v("DJ / 音樂會")])])])])]), _c('div', {
    staticClass: "list col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_vm._v("BYOC舞台")]), _c('div', {
    staticClass: "list-content"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("13:30-14:30")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("Gigabyte 工商時間"), _c('br'), _vm._v("(AORUS彩盒疊疊樂)")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("15:00-16:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("GeForce X 誰是槍王")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("16:00-18:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("GeForce X WirForce"), _c('br'), _vm._v("肥宅運動大會")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("19:00-21:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("中華電信 X WirForce"), _c('br'), _vm._v("知識王 II")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("23:30-00:30")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("WirForce Just Dance"), _c('br'), _vm._v("熱舞大賽 IV")])])])])]), _c('div', {
    staticClass: "list col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_vm._v("野台")]), _c('div', {
    staticClass: "list-content"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("12:00-12:30")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("MSI x 閃電狼粉絲見面會")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("13:00-13:30")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("AGON電競顯示器"), _c('br'), _vm._v("視感對決")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("14:00-14:30")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("璐加雪糖")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("14:30-20:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("熱舞大賽 IV"), _c('br'), _vm._v("《 Just Dance 舞力全開2018 》")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list col-sm-4 col-md-3 col-md-offset-1"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_vm._v("主舞台")]), _c('div', {
    staticClass: "list-content"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("11:00-13:30")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("台北盃電競大賽"), _c('br'), _vm._v("團體項目總決賽 -《傳說對決》")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("13:30-16:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("台北盃電競大賽"), _c('br'), _vm._v("個人項目 總決賽 -《快打旋風 V》")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("16:30-17:00")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("WirForce 2017"), _c('br'), _vm._v("成就獎項頒發")])]), _c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("17:00-17:30")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("閉幕")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_vm._v("WirForce"), _c('br'), _vm._v("收垃圾清場大作戰")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_vm._v("野台")]), _c('div', {
    staticClass: "list-content"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "time"
  }, [_vm._v("12:00-15:30")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("WirForce 次元的聲音"), _c('br'), _vm._v("欣家"), _c('br'), _vm._v("Kameko | 龜子"), _c('br'), _vm._v("LOAM"), _c('br'), _vm._v("赤咲"), _c('br'), _vm._v("DJ Sean Wang")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dffc9a54"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/programList.vue
// module id = 586
// module chunks = 1